import { Box, Button, Tooltip } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useWhapi } from 'context';
import { OutputLogInterface } from 'type/type';

const OutputBox = () => {
  const { output, groupFN, setOutput } = useWhapi();
  const endOfMessagesRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (endOfMessagesRef.current) endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [output]);

  return (
    <Box
      sx={{
        flexGrow: 1,
        minWidth: 300,
        padding: '10px 20px',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '550px',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant={'text'} onClick={() => setOutput([])}>
          <p style={{ fontSize: 10, paddingLeft: '5px' }}>Clear Logs</p>
        </Button>
      </Box>
      <Box sx={{ overflowY: 'auto', flexGrow: 1, margin: '10px 0' }}>
        {output.map((line: OutputLogInterface, index: number) => {
          if (line.message) return <p key={index}>{line.message}</p>;
          if (line.content)
            return (
              <Box className={'noselect'} key={index} sx={{ display: 'flex', flexDirection: 'column', gap: '5px', margin: '10px 5px', padding: '5px', boxShadow: '2px 2px 5px var(--black01)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Tooltip title={line.content.sent ? 'Sent' : 'Failed'}>
                    <Box sx={{ width: '15px', height: '15px', bgcolor: line.content.sent ? 'green' : 'red', borderRadius: '3px', opacity: 0.7, boxShadow: '2px 2px 5px var(--black02)' }}></Box>
                  </Tooltip>
                  <Tooltip title={line.ts}>
                    <p style={{ opacity: 0.7 }}>[{line.ts}]</p>
                  </Tooltip>
                </Box>
                <p>
                  <span style={{ padding: '5px', backgroundColor: 'var(--black01)', fontWeight: 600, borderRadius: '5px', marginRight: '5px' }}>
                    Message was {line.content.sent ? 'sent' : 'attempted to send'} to [ {groupFN(line.content.message.chat_id)} ] :
                  </span>
                  {line.content.message.text.body}
                </p>
                <div ref={endOfMessagesRef} />
              </Box>
            );
          if (line.image)
            return (
              <Box className={'noselect'} key={index} sx={{ display: 'flex', flexDirection: 'column', gap: '5px', margin: '10px 5px', padding: '5px', boxShadow: '2px 2px 5px var(--black01)' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Tooltip title={line.image.sent ? 'Sent' : 'Failed'}>
                    <Box sx={{ width: '15px', height: '15px', bgcolor: line.image.sent ? 'green' : 'red', borderRadius: '3px', opacity: 0.7, boxShadow: '2px 2px 5px var(--black02)' }}></Box>
                  </Tooltip>
                  <Tooltip title={line.ts}>
                    <p style={{ opacity: 0.7 }}>[{line.ts}]</p>
                  </Tooltip>
                </Box>
                <p>
                  <span style={{ padding: '5px', backgroundColor: 'var(--black01)', fontWeight: 600, borderRadius: '5px', marginRight: '5px' }}>
                    Image was {line.image.sent ? 'sent' : 'attempted to send'} to [ {groupFN(line.image.message.chat_id)} ] :
                  </span>
                  <img
                    src={line.image.message.image.preview}
                    alt='Loaded from base64'
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </p>
                <div ref={endOfMessagesRef} />
              </Box>
            );
        })}
      </Box>
    </Box>
  );
};

export default OutputBox;
